import db from "../../db";
import { loadActiveUser } from "../users/usersActions";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { castImputationForServerFormat, castImputationForClientFormat } from "./imputationsCast";
import { checkOverlapping, checkOverlappingOnlyDriving } from "./imputationsChecks";
import { throwErrorMessage } from "../../lib/error_helper";
import {
    addImputationSuccess,
    deleteImputationSuccess,
    updateImputationSuccess,
    getAllImputations,
    getImputationsById,
    getImputationsBetweenImputation,
    gotActivityInProgress,
    imputationIsLoadingAction,
} from "./imputationsActions";
import { ERROR } from "./imputationsConstants";
import { getCurrentDate } from "../../time";
import { clone } from "../../utils";
import moment from "moment";
import { getActivityTypeById } from "../activityTypes/activityTypesActions";
import { validateDayOnly } from "../day/dayEditionActions";

export function updateImputationInDb(id, imputation) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            db.transaction("rw?", db.Imputation, db.User, () => {
                let adaptedImputation = adaptImputationForDb(imputation);

                return db.Imputation.update(id, adaptedImputation)
                    .then(() => {
                        setAndSaveImputationThroughApi(id, "UPDATE");
                        dispatch(getAllImputations());
                        return resolve(imputation);
                    })
                    .catch((err) => {
                        return reject(err);
                    });
            }).catch((err) => {
                return reject(err);
            });
        });
    };
}

export function adaptImputationForDb(imputation) {
    let adaptedImputation = clone(imputation);

    if (adaptedImputation.date_start) adaptedImputation.date_start = adaptedImputation.date_start.toDate();

    if (!(adaptedImputation.date_end instanceof Date))
        adaptedImputation.date_end =
            adaptedImputation.date_end && moment.isMoment(adaptedImputation.date_end)
                ? adaptedImputation.date_end.toDate()
                : undefined;

    return adaptedImputation;
}

export function adaptImputationForMyOpen(imputation) {
    let adaptedImputation = clone(imputation);

    adaptedImputation.date_start = moment(imputation.date_start);
    adaptedImputation.date_end = moment(imputation.date_end);

    return adaptedImputation;
}

export function addImputation(imputation) {
    return (dispatch) => {
        db.Imputation.add(imputation)
            .then(async (id) => {
                dispatch(addImputationSuccess(imputation));
                dispatch(getAllImputations());
            })
            .catch((err) => {
                console.error("Erreur : imputationsActions - addImputation");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de l'ajout de l'imputation",
                    })
                );
                dispatch({
                    type: ERROR,
                    info: "ajout de l'imputation",
                    error: err,
                });
            });
    };
}

export function addImputationInDb(imputation) {
    return async (dispatch) => {
        if (!imputation.date_start) console.error("addImputationInDb");

        return await db
            .transaction("rw?", db.Imputation, db.User, async () => {
                if (await checkOverlapping(imputation, true)) {
                    dispatch(
                        throwErrorMessage({
                            title: "Erreur",
                            message: "Chevauchement non autorisé",
                        })
                    );

                    return;
                }

                let clonedImputation = JSON.parse(JSON.stringify(imputation));
                clonedImputation.date_start = new Date(clonedImputation.date_start);
                clonedImputation.date = new Date(clonedImputation.date);

                if (clonedImputation.date_end) clonedImputation.date_end = new Date(clonedImputation.date_end);

                db.Imputation.add(clonedImputation)
                    .then(async (id) => {
                        let data = clonedImputation;
                        data.id = id;
                        dispatch(addImputationSuccess(data));
                        setAndSaveImputationThroughApi(id, "ADD");
                        dispatch(getAllImputations());
                    })
                    .catch((err) => {
                        console.error("Erreur : imputationsActions - addImputationInDb");
                        dispatch(
                            throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors de l'ajout de l'imputation",
                            })
                        );
                        dispatch({
                            type: ERROR,
                            info: "ajout de l'imputation",
                            error: err,
                        });
                    });
            })
            .catch((err) => {
                console.error("Erreur : imputationsActions - addImputationInDb");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de l'ajout de l'imputation",
                    })
                );
                dispatch({
                    type: ERROR,
                    info: "ajout de l'imputation",
                    error: err,
                });
            });
    };
}

export function cleanOldImputations() {
    return (dispatch) => {
        db.transaction("rw?", db.Imputation, () => {
            let imputationsToDelete = [];
            db.Imputation.toArray()
                .then((imputations) => {
                    let OneMonthAgo = moment().add(-1, "month");

                    imputations.forEach((imputation) => {
                        let imputationDate = moment(new Date(imputation.date_start));
                        if (imputationDate < OneMonthAgo) {
                            imputationsToDelete.push(imputation);
                        }
                    });

                    return imputationsToDelete;
                })
                .then((imputationsToDelete) => {
                    imputationsToDelete.forEach((imputation) => {
                        dispatch(deleteImputationInDb(imputation.id));
                    });
                })
                .catch((err) => {
                    console.error("Erreur : imputationsEditionActions - cleanOldImputations");
                    let message = "Une erreur s'est produite lors de la purge des anciennes imputations";

                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: message,
                        })
                    );
                });
        }).catch((err) => {
            console.error("Erreur : imputationsEditionActions - cleanOldImputations " + err.message);
            let message = "Une erreur s'est produite lors de la purge des anciennes imputations";

            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: message,
                })
            );
        });
    };
}

export function deleteImputationInDb(id) {
    return (dispatch) => {
        db.transaction("rw?", db.Imputation, db.User, async () => {
            await db.Imputation.delete(id)
                .then(async () => {
                    dispatch(deleteImputationSuccess(id));
                    dispatch(getAllImputations());
                })
                .catch((err) => {
                    console.error("Erreur : imputationsActions - deleteImputation");
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la suppression d'une imputation !",
                        })
                    );
                    dispatch({
                        type: ERROR,
                        info: "suppression de l'imputation " + id,
                        error: err,
                    });
                });
        }).catch((err) => {
            console.error("Erreur : imputationsActions - deleteImputation");
            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la suppression d'une imputation !",
                })
            );
            dispatch({ type: ERROR, info: "", error: err });
        });
    };
}

export function updateImputation(id, imputation) {
    return (dispatch) => {
        if (!imputation.date_start) console.error("updateImputation");

        db.transaction("rw?", db.Imputation, db.User, async () => {
            db.Imputation.update(id, imputation)
                .then(async () => {
                    setAndSaveImputationThroughApi(id, "UPDATE");
                    imputation.id = id;
                    dispatch(updateImputationSuccess(imputation));
                    dispatch(getAllImputations());
                })
                .catch((err) => {
                    console.error("Erreur : imputationsActions - updateImputation", err);
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la modification de l'imputation " + id,
                        })
                    );
                    dispatch({
                        type: ERROR,
                        info: "modification de l'imputation " + id,
                        error: err,
                    });
                });
        });
    };
}

export function deleteImputation(id) {
    return (dispatch) => {
        getImputationsById(id).then((imputation) => {
            db.transaction("rw?", db.Imputation, db.User, async () => {
                await db.Imputation.delete(id)
                    .then(async () => {
                        dispatch(deleteImputationSuccess(id));
                        setAndSaveImputationThroughApi(id, "DELETE", imputation.date, imputation.date_start);
                        dispatch(getAllImputations());
                    })
                    .catch((err) => {
                        console.error("Erreur : imputationsActions - deleteImputation");
                        dispatch(
                            throwErrorMessage({
                                errorObject: err,
                                title: "Erreur",
                                message: "Erreur lors de la suppression d'une imputation !",
                            })
                        );
                        dispatch({
                            type: ERROR,
                            info: "suppression de l'imputation " + id,
                            error: err,
                        });
                    });
            }).catch((err) => {
                console.error("Erreur : imputationsActions - deleteImputation");
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la suppression d'une imputation !",
                    })
                );
                dispatch({ type: ERROR, info: "", error: err });
            });
        });
    };
}

export function deleteAllImputationByDay(day_id) {
    return (dispatch) => {
        db.Imputation.where("day_id")
            .equals(day_id)
            .each(async (imputation) => {
                dispatch(deleteImputation(imputation.id));
                dispatch(getAllImputations());
            })
            .catch((data) => {
                console.error("suppression des imputations du jour échouée : " + data);
            });
    };
}

export function saveImputationThroughApi(imputation, action, dateImputation = null, startDateImputation = null) {
    loadActiveUser()((userAct) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            user_id: userAct.user.id,
            empId: userAct.user.emp_id,
            type: action,
            date: dateImputation ? dateImputation : imputation.date,
            imputation:
                action !== "DELETE"
                    ? castImputationForServerFormat(imputation, userAct.user)
                    : {
                          lineId: imputation.id,
                          empId: userAct.user.emp_id,
                          startTime: startDateImputation,
                      },
        });

        fetchWithTimeout("/api/v1/imputation", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
            })
            .catch((err) => {
                console.error("Erreur : imputationsActions - saveImputationThroughApi", err);
                //Quand on créé une imputation, pas forcément besoin de joindre le serveur.
                //La synchronisation au serveur se fait à la validation de la journée
                //Ici c'est du plus. Si on y arrive pas tant pis
            });
    });
}

export function stopImputationInDb(id, time) {
    return (dispatch) => {
        dispatch(updateImputation(id, { date_end: time, in_progress: false }));
    };
}

function reducePreviousActivityAndGetInProgress(newImputation, imputations) {
    return (dispatch) => {
        return new Promise(async (resolve) => {
            let inProgress = null;
            imputations.forEach((currentImputation) => {
                if (currentImputation.in_progress) {
                    inProgress = currentImputation;
                    return;
                }

                //Raccourcir l'activité (avec fin déterminée) précédente si besoin
                let now = getCurrentDate(true);
                let existedImputationEndDate = currentImputation.in_progress ? now : currentImputation.date_end;

                if (currentImputation.date_start < newImputation.date_start) {
                    //courante commençant avant la nouvelle
                    if (existedImputationEndDate > newImputation.date_start) {
                        //courante finissant dans ou après la nouvelle
                        dispatch(
                            updateImputationInDb(currentImputation.id, {
                                date_end: newImputation.date_start,
                                in_progress: false,
                            })
                        ).catch((data) => {
                            console.error("modification d'imputation échouée : " + data);
                        });
                    }

                    return;
                }
            });

            return resolve(inProgress);
        });
    };
}

export async function setAndSaveImputationThroughApi(
    id_imputation,
    action,
    dateImputation = null,
    startDateImputation = null
) {
    let imputation = await getImputationsById(id_imputation);
    saveImputationThroughApi(
        imputation === undefined ? { id: id_imputation } : imputation,
        action,
        dateImputation,
        startDateImputation
    );
}

//Shorten driving ¯\_(ツ)_/¯
export function stopInProgressActivity(newImputation, onError) {
    return async (dispatch) => {
        //callback function(erreur, message, imputation);
        let data = await getImputationsBetweenImputation(newImputation);

        if (data.length === 0) return newImputation;

        if (data.length === 0) {
            return newImputation;
        }

        if (checkOverlappingOnlyDriving(data, onError)) {
            return null;
        }

        return dispatch(reducePreviousActivityAndGetInProgress(newImputation, data))
            .then((inProgress) => {
                if (inProgress === null) {
                    return newImputation; //Pas d'activité en cours
                }

                return gotActivityInProgress(inProgress).then(async (gotActivityInProgress) => {
                    if (!gotActivityInProgress) {
                        onError("L'imputation en cours chevauche une autre imputation");
                        return null;
                    }

                    //Une activité en cours existante qui est avant la nouvelle
                    //Alors on arrête l'activité en cours à l'horaire du début de la nouvelle
                    if (inProgress.date_start < newImputation.date_start) {
                        dispatch(
                            updateImputationInDb(inProgress.id, {
                                date_end: moment(newImputation.date_start),
                                in_progress: false,
                            })
                        ).catch((data) => {
                            console.error("modification d'imputation échouée : " + data);
                        });
                    } else if (inProgress.date_start.getTime() === newImputation.date_start.getTime()) {
                        onError("L'imputation en cours chevauche une autre imputation");
                        return null;
                    }

                    return newImputation;
                });
            })
            .catch((err) => {
                console.error(err);
                throw err;
            });
    };
}

export function deleteImputations(imputations) {
    return (dispatch) => {
        if (imputations !== undefined) {
            for (let i = 0; i < imputations.length; i++) {
                dispatch(deleteImputation(imputations[i].id));
            }
        }
    };
}

export function deleteImputationsInDb(imputations) {
    return (dispatch) => {
        if (imputations !== undefined) {
            for (let i = 0; i < imputations.length; i++) {
                dispatch(deleteImputationInDb(imputations[i].id));
            }
        }
    };
}

export function currentImputationsFetchData(current_day, activeUser) {
    return (dispatch) => {
        dispatch(imputationIsLoadingAction(true));

        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/imputations/all_current/" + activeUser.emp_id, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(imputationIsLoadingAction(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then(async (imputations) => {
                if (imputations.length > 0) {
                    let lastInProgress;
                    let isDayValidated = false;
                    // Ajout des imputations de la journée liées à l'utilisateur courant et en provenance d'OpenERP
                    for (let i = 0; i < imputations.length; i++) {
                        var activity = await getActivityTypeById(imputations[i].activity_type_id[0]);
                        let imp = castImputationForClientFormat(imputations[i], current_day, activity);
                        dispatch(addImputation(imp));

                        if (imp.in_progress) {
                            if (lastInProgress === undefined) {
                                lastInProgress = imp;
                            } else if (imp.date_start > lastInProgress.date_start) {
                                lastInProgress.date_end = new Date();
                                lastInProgress.in_progress = false;
                                dispatch(updateImputation(lastInProgress.id, lastInProgress));
                                lastInProgress = imp;
                            } else {
                                imp.date_end = new Date();
                                imp.in_progress = false;
                                dispatch(updateImputation(imp.id, imp));
                            }
                        }

                        if (!isDayValidated && imputations[i].validated) {
                            isDayValidated = true;
                        }
                    }

                    if (isDayValidated) {
                        dispatch(validateDayOnly(current_day));
                    }
                    // Voir pour la récup de toutes les imputations dans le nextProps
                    //dispatch(getAllImputations());
                }
            })
            .catch((err) => {
                console.error("Erreur : imputationsEditionActions - currentImputationsFetchData", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des imputations !",
                    })
                );

                dispatch(imputationIsLoadingAction(false));
            });
    };
}
